import { render, staticRenderFns } from "./VehicleInformation.vue?vue&type=template&id=11f85891&lang=pug&"
import script from "./VehicleInformation.vue?vue&type=script&lang=ts&"
export * from "./VehicleInformation.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports